if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

if (typeof Math.sign === 'undefined') { Math.sign = function (x) { return x > 0 ? 1 : x < 0 ? -1 : x; } }
if (typeof Math.trunc === 'undefined') { Math.trunc = function (x) { return x - (x % 1); } }

const METERS_PER_FOOT = 0.3048;

const format = Object.create(null, {
  FEET: { get: function get() {
      return _forward(METERS_PER_FOOT);
    }, enumerable: true },
  FT: { get: function get() {
      return _forward(METERS_PER_FOOT);
    }, enumerable: true },
  F: { get: function get() {
      return _forward(METERS_PER_FOOT);
    }, enumerable: true },
  METERS: { get: function get() {
      return _forward(1);
    }, enumerable: true },
  M: { get: function get() {
      return _forward(1);
    }, enumerable: true },
  KM: { get: function get() {
      return _forward(1e3);
    }, enumerable: true },
  CM: { get: function get() {
      return _forward(1e-2);
    }, enumerable: true }
});

function _forward(base) {
  return Object.create(null, {
    to: { get: function get() {
        return _fmtFrom(base);
      } },
    as: { get: function get() {
        return _fmtFrom(base);
      } }
  });
}
function _fmtFrom(base) {
  return Object.assign(Object.create(null, {
    FEET: { get: function get() {
        return _fmtToFT(base);
      } },
    FT: { get: function get() {
        return _fmtToFT(base);
      } },
    F: { get: function get() {
        return _fmtToFT(base);
      } }
  }), {
    M: function M(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' m' : arguments[1];
      return _fmtToSI(base, 'm', digits, sfx);
    },
    METERS: function METERS(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' m' : arguments[1];
      return _fmtToSI(base, 'm', digits, sfx);
    },
    KM: function KM(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' km' : arguments[1];
      return _fmtToSI(base, 'km', digits, sfx);
    },
    CM: function CM(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' cm' : arguments[1];
      return _fmtToSI(base, 'cm', digits, sfx);
    }
  });
}
function _fmtToFT(base) {
  return Object.assign(Object.create(null, {
    IN: { get: function get() {
        return _fmtToFT_IN(base);
      } },
    INCHES: { get: function get() {
        return _fmtToFT_IN(base);
      } }
  }), {
    DEC: function DEC(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' ft' : arguments[1];
      return _fmtToFT_DEC(base, digits, sfx);
    },
    DECIMAL: function DECIMAL(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? ' ft' : arguments[1];
      return _fmtToFT_DEC(base, digits, sfx);
    }
  });
}
function _sfxFTIN(sfx) {
  if (Array.isArray(sfx) && sfx.length == 2) {
    return sfx;
  }
  return ["'", '"'];
}
function _fmtToFT_IN(base) {
  return {
    DEC: function DEC(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? _sfxFTIN() : arguments[1];
      return _fmtToFT_IN_DEC(base, digits, sfx);
    },
    DECIMAL: function DECIMAL(digits) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? _sfxFTIN() : arguments[1];
      return _fmtToFT_IN_DEC(base, digits, sfx);
    },
    FRAC: function FRAC(denom) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? _sfxFTIN() : arguments[1];
      return _fmtToFT_IN_FRAC(base, denom, sfx);
    },
    FRACTIONAL: function FRACTIONAL(denom) {
      var sfx = arguments.length <= 1 || arguments[1] === undefined ? _sfxFTIN() : arguments[1];
      return _fmtToFT_IN_FRAC(base, denom, sfx);
    }
  };
}
function _fmtToFT_DEC(base, digits, sfx) {
  return function (valueIn) {
    var val = valueIn * (base / METERS_PER_FOOT);
    return 1 * val.toFixed(digits) + sfx;
  };
}
function _fmtToFT_IN_DEC(base, digits, sfx) {
  sfx = _sfxFTIN(sfx);
  return function (valueIn) {
    var val = valueIn * (base / METERS_PER_FOOT);
    var feet = Math.trunc(val);
    var inches = Math.abs((12 * (val - feet)).toFixed(digits));
    if (inches === 12) {
      inches = 0;
      feet += Math.sign(val);
    }
    return feet + sfx[0] + Math.abs(inches.toFixed(digits)) + sfx[1];
  };
}
function _fmtToFT_IN_FRAC(base, denom, sfx) {
  sfx = _sfxFTIN(sfx);
  if (!denom || !isFinite(denom) || denom < 1) {
    denom = 16;
  }
  var denomConst = denom;

  return function (valueIn) {
    var denom = denomConst; // Because "denom" will change during fraction simplification!
    var val = valueIn * (base / METERS_PER_FOOT);
    var feet = Math.trunc(val);
    var inches = 12 * (val - feet);
    var wholeInches = Math.trunc(inches);
    var numerator = Math.round(denom * (inches - wholeInches));
    if (numerator === 0) {
      return feet + sfx[0] + Math.abs(wholeInches) + sfx[1];
    }
    while (numerator % 2 === 0 && denom % 2 === 0) {
      numerator /= 2;
      denom /= 2;
    }
    return feet + sfx[0] + Math.abs(wholeInches) + ' ' + Math.abs(numerator) + '/' + denom + sfx[1];
  };
}

var _siUnits = {
  pm: 1e-12,
  nm: 1e-9,
  um: 1e-6,
  mm: 1e-3,
  cm: 1e-2,
  m: 1,
  km: 1e+3
};
function _fmtToSI(base, units, digits, sfx) {
  var unitSz = _siUnits[units];
  if (unitSz === undefined) throw 'Unsupported SI length unit';
  return function (valueIn) {
    var val = valueIn * (base / unitSz);
    return 1 * val.toFixed(digits) + sfx;
  };
}


function _parseUnit(strIn) {
  var s_siPrefix = {
    m: 1,
    cm: 1e-2,
    mm: 1e-3,
    um: 1e-6,
    nm: 1e-9,
    pm: 1e-12,
    km: 1e+3
  };

  if (!strIn || typeof strIn !== 'string') {
    return NaN;
  }
  var str = strIn.trim()
    .replace(/[‘’′ʼ`]/g, "'")
    .replace(/[“”″ʺ]/g, '"');
  if (str.length == 0) {
    return NaN;
  }

  // Try +-: 1/2", 11/16"; trailing space OK, but nothing else
  // Note: Trailing " is mandatory!
  {
    var lm = str.match(/^([+-]?\d+)\/(\d+)(\"|\'\'|“|”|‘‘|’’|``) *$/);
    if (lm) {
      return parseFloat(lm[1]) / parseFloat(lm[2]) / 12.0;
    }
  }

  // Try +-: 5, 1.2e7, .1e+2, 3e-1, 3.e1
  var firstFloat = NaN;
  {
    var _lm = str.match(/^[+-]? *(?:\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?/i);
    if (!_lm) {
      return NaN;
    }
    firstFloat = parseFloat(_lm[0].replace(/ */g, '')); // Clear spaces on the way
    str = str.slice(_lm[0].length); // Don't trim just yet!
  }

  if (str.length == 0 || isNaN(firstFloat)) {
    return firstFloat;
  }

  var sgn = Math.sign(firstFloat);
  if (sgn === 0) {
    sgn = 1;
  }

  // If inches, then end of story
  if (str.match(/^(\"|’’| *in| *inche?s?|\'\'|“|”|‘‘|``) *$/i)) {
    return firstFloat / 12.0;
  }
  {
    var _lm2 = str.match(/^ +(\d+)\/(\d+)(\"|’’|\'\'|“|”|‘‘|``| *inche?s?) *$/i);
    if (_lm2) {
      // If original input was: 7 11/16"
      return (firstFloat + sgn * parseFloat(_lm2[1]) / parseFloat(_lm2[2])) / 12.0;
    }
  }
  // Try explicit units
  {
    var _lm3 = str.match(/^ *(m|cm|mm|um|nm|pm|km) *$/i);
    if (_lm3) {
      // Return an array to signal that the output is in METERS:
      return [firstFloat * s_siPrefix[_lm3[1]], true];
    }
  }

  // Should be feet now
  {
    var _lm4 = str.match(/^(?:\'| *ft| *feet|’|‘|`|\-| +-?) */i); // Order matters here!
    if (!_lm4) {
      return NaN;
    }
    str = str.slice(_lm4[0].length).trim();
    if (str.length == 0) {
      if (_lm4[0].match(/-/)) {
        return NaN; // Trailing dash - e.g. strIn was: 7-
      }
      return firstFloat;
    }
  }

  // Now we can only have left: 2, 2.3, 7/8, 2 7/8, with an optional " at the end
  {
    var _lm5 = str.match(/^(\d+(?:\.\d*)?)(?:\"|’’| *in| *inche?s?|\'\'|“|”|‘‘|``)? *$/);
    if (_lm5) {
      return firstFloat + sgn * parseFloat(_lm5[1]) / 12.0;
    }
    _lm5 = str.match(/^(\d+)\/(\d+)(\"|’’| *in| *inche?s?|\'\'|“|”|‘‘|``)? *$/);
    if (_lm5) {
      return firstFloat + sgn * (parseFloat(_lm5[1]) / parseFloat(_lm5[2])) / 12.0;
    }
    _lm5 = str.match(/^(\d+)\s*-\s*(\d+)\/(\d+)(\"|’’| *in| *inche?s?|\'\'|“|”|‘‘|``)? *$/);
    if (_lm5) {
      return firstFloat + sgn * (parseFloat(_lm5[1]) + parseFloat(_lm5[2]) / parseFloat(_lm5[3])) / 12.0;
    }
    _lm5 = str.match(/^(\d+) +(\d+)\/(\d+)(\"|’’| *in| *inche?s?|\'\'|“|”|‘‘|``)? *$/);
    if (_lm5) {
      return firstFloat + sgn * (parseFloat(_lm5[1]) + parseFloat(_lm5[2]) / parseFloat(_lm5[3])) / 12.0;
    }
  }

  return NaN;
}

function parseUnit(unit) {
  var num = _parseUnit(unit);
  if (typeof num === 'number') {
    return num;
  }
  return num[0] / METERS_PER_FOOT;
}

export { format, parseUnit };
